import { useTranslation } from "react-i18next";
import { X } from "lucide-react";
import Button from "../Common/Button";

const LearnMoreModal = ({ isOpen, onClose }) => {
    const { t } = useTranslation();
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4 sm:px-6 py-4">
            <div className="relative h-full w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-[0_20px_60px_rgba(0,0,0,0.2)] md:max-w-5xl">
                <button
                    type="button"
                    onClick={onClose}
                    className="absolute right-4 top-4 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-white/90 shadow focus:outline-none"
                >
                    <X className="h-6 w-6 text-primary" />
                </button>
                <div className="grid h-full grid-cols-1 md:grid-cols-2">
                    <div className="relative order-first h-48 w-full overflow-hidden sm:h-56 md:order-none md:h-full">
                        <img
                            src="/assets/images/common/learning-popup.png"
                            alt=""
                            className="h-full w-full object-cover"
                        />
                        <div className="absolute inset-0 bg-white/10" />
                    </div>
                    <div className="flex h-full flex-col justify-center overflow-y-auto p-6 sm:p-8 md:p-12">
                        <img
                            src="/assets/icons/korres-shares-logo.png"
                            alt={t("AUTH_LEARN_MODAL_ALT_KORRES_SHARES")}
                            className="h-[4.5rem] w-[4.5rem]"
                        />
                        <h2 className="mt-6 text-xl font-semibold text-primary">
                            {t("AUTH_LEARN_MODAL_TITLE")}
                        </h2>
                        <ol className="mt-6 space-y-5 text-sm text-slate-600">
                            <li className="flex gap-3">
                                <span className="font-semibold text-primary">1.</span>
                                {t("AUTH_LEARN_MODAL_STEP_1")}
                            </li>
                            <li className="flex gap-3">
                                <span className="font-semibold text-primary">2.</span>
                                {t("AUTH_LEARN_MODAL_STEP_2")}
                            </li>
                            <li className="flex gap-3">
                                <span className="font-semibold text-primary">3.</span>
                                {t("AUTH_LEARN_MODAL_STEP_3")}
                            </li>
                            <li className="flex gap-3">
                                <span className="font-semibold text-primary">4.</span>
                                {t("AUTH_LEARN_MODAL_STEP_4")}
                            </li>
                        </ol>
                        <Button
                            type="button"
                            onClick={onClose}
                            className="mt-10 w-full"
                        >
                            {t("AUTH_LEARN_MODAL_CREATE_ACCOUNT")}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LearnMoreModal;
